/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Audience_TournamentInputs */

const en_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tournament`)
};

const es_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torneo`)
};

const de_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turnier`)
};

const zh_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比赛`)
};

const ar_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنافسي`)
};

const fr_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tournoi`)
};

const vi_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giải đấu`)
};

const sw_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mashindano`)
};

const th_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทัวร์นาเมนต์`)
};

const bs_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turnir`)
};

const ja_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トーナメント`)
};

const ko_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`토너먼트`)
};

const pt_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torneio`)
};

const it_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torneo`)
};

const sv_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turnering`)
};

const nl_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toernooi`)
};

const da_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turnering`)
};

const nb_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turnering`)
};

const fi_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turnaus`)
};

const pl_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turniej`)
};

const ru_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Турнир`)
};

const tr_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turnuva`)
};

const hi_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टूर्नामेंट`)
};

const id_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turnamen`)
};

const ms_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kejohanan`)
};

const cs_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turnaj`)
};

const el_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τουρνουά`)
};

const he_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טורניר`)
};

const af_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toernooi`)
};

const hu_method_audience_tournament = /** @type {(inputs: Method_Audience_TournamentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verseny`)
};

/**
* | output |
* | --- |
* | "Tournament" |
*
* @param {Method_Audience_TournamentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_audience_tournament = /** @type {((inputs?: Method_Audience_TournamentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Audience_TournamentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_audience_tournament(inputs)
	if (locale === "de") return de_method_audience_tournament(inputs)
	if (locale === "zh") return zh_method_audience_tournament(inputs)
	if (locale === "ar") return ar_method_audience_tournament(inputs)
	if (locale === "fr") return fr_method_audience_tournament(inputs)
	if (locale === "vi") return vi_method_audience_tournament(inputs)
	if (locale === "sw") return sw_method_audience_tournament(inputs)
	if (locale === "th") return th_method_audience_tournament(inputs)
	if (locale === "bs") return bs_method_audience_tournament(inputs)
	if (locale === "ja") return ja_method_audience_tournament(inputs)
	if (locale === "ko") return ko_method_audience_tournament(inputs)
	if (locale === "pt") return pt_method_audience_tournament(inputs)
	if (locale === "it") return it_method_audience_tournament(inputs)
	if (locale === "sv") return sv_method_audience_tournament(inputs)
	if (locale === "nl") return nl_method_audience_tournament(inputs)
	if (locale === "da") return da_method_audience_tournament(inputs)
	if (locale === "nb") return nb_method_audience_tournament(inputs)
	if (locale === "fi") return fi_method_audience_tournament(inputs)
	if (locale === "pl") return pl_method_audience_tournament(inputs)
	if (locale === "ru") return ru_method_audience_tournament(inputs)
	if (locale === "tr") return tr_method_audience_tournament(inputs)
	if (locale === "hi") return hi_method_audience_tournament(inputs)
	if (locale === "id") return id_method_audience_tournament(inputs)
	if (locale === "ms") return ms_method_audience_tournament(inputs)
	if (locale === "cs") return cs_method_audience_tournament(inputs)
	if (locale === "el") return el_method_audience_tournament(inputs)
	if (locale === "he") return he_method_audience_tournament(inputs)
	if (locale === "af") return af_method_audience_tournament(inputs)
	if (locale === "hu") return hu_method_audience_tournament(inputs)
	return en_method_audience_tournament(inputs)
});